/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import GenericTable from "../../components/GenericTable";
import LangContext from "../../contextProvider/LangContext";
import moment from "moment";
import DashboardDateChecker from "../../components/DashboardDateChecker";
import PageToolbar from "../../components/PageToolbar";
import { Button, Card, Checkbox, Col, Form } from "antd";
import { Row } from "antd/es/grid";
import DateTimePicker from "../../components/DateTimePicker";
import GenericSelectorBranches from "../../components/GenericSelectorBranches";
import GenericSelectorItemTags from "../../components/GenericSelectorItemTags";
import { Job, OutputType, ProcessType, User } from "../../JmReact";
import GenericModal from "../../components/GenericModal";
import ResponsiveTable from "../../components/ResponsiveTable";
import TableIDs from "../../data/TableIDs";
import GenericSelector from "../../components/GenericSelector";


class DynamicSalesDisplay extends Component {
    constructor(props: Props) {
        super(props);
        this.state = {
            _date: moment().format("YYYY-MM-DD"),
            _fromHour: '00:00:00',
            _toHour: '00:00:00',
            _branchList: '',
            _itemTagList: '',
            _docTypeList: '',
            modalOpen: false,
            viewPerBranch: false,
            viewPerItem: false,
            loading: false
        };

        this.id = "DYNAMIC_SALES_DISPLAY";

        this.api = {
            get: "get_dynamic_sales_display"
        }

        this.selectors = [
            { id: TableIDs.genericSelectorDocumentTypes, api: "get_document_types_list" },
        ];

        this.selectors.forEach(x => {
            if (props.data[x.id] === undefined) props.data[x.id] = { ...props.data.genericSelector }
        });

        if (props.data[this.id] === undefined) props.data[this.id] = {
            primaryDataset: [],
            branchDataset: [],
            itemDataset: [],
            branchItemDataset: [],
            sumAll: 0,
            countAll: 0
        };

    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidMount() {
        this.sendAPI("get_all_gp_by_user", "", ob => {
            if (ob.data) {
                ob.data.split("\r").forEach(x => {
                    let y = x.split("\f");
                    if (y[0] == 'GP_StartDayHour' && y[1] && y[1].length == 5) {
                        let _fromHour = y[1] + ":00"
                        let _toHour = moment("2020-01-02 " + _fromHour).add(-1, "second").format("HH:mm:ss")
                        this.setState({ _fromHour, _toHour })
                    }
                })
            }
        })
    }

    componentDidUpdate() {
        document.title = "Cash On Tab - " + this.getText(21315);
    }

    apiTable = () => {
        this.setState({ loading: true }, () => {

            const { _date, _fromHour, _toHour, _branchList, _itemTagList, _docTypeList } = this.state
            this.sendAPI(this.api.get, { _date, _fromHour, _toHour, _branchList, _itemTagList, _docTypeList }, ob => {
                let primaryDataset = [];
                let branchDataset = []
                let itemDataset = []
                let branchItemDataset = []
                let sumAll = 0;
                let countAll = 0;

                if (ob.data) {
                    ob.data.split("\r").map(x => {

                        let y = x.split("\f")

                        let _branchId = y[0]
                        let _branchName = y[1]
                        let _tagId = y[2]
                        let _tagName = y[3]
                        let _itemId = y[4]
                        let _itemName = y[5]

                        let _datetime = y[6]
                        let _docNum = y[7]
                        let _ref2 = y[8]
                        let _custName = y[9]
                        let _sum = parseFloat(y[10]) ? parseFloat(y[10]) : 0
                        let _count = parseFloat(y[11]) ? parseFloat(y[11]) : 0

                        sumAll += _sum;
                        countAll += _count;

                        let findPrimary = primaryDataset.findIndex(f => f._tagId == _tagId)
                        let findBranch = branchDataset.findIndex(f => f._branchId == _branchId && f._tagId == _tagId)
                        let findItem = itemDataset.findIndex(f => f._itemId == _itemId && f._tagId == _tagId)
                        let findBranchItem = branchItemDataset.findIndex(f => f._itemId == _itemId && f._branchId == _branchId && f._tagId == _tagId)

                        if (findPrimary > -1) {
                            primaryDataset[findPrimary] = {
                                ...primaryDataset[findPrimary],
                                _sum: primaryDataset[findPrimary]._sum + _sum,
                                _count: primaryDataset[findPrimary]._count + _count,
                                detaild: [
                                    ...primaryDataset[findPrimary].detaild,
                                    { _datetime, _docNum, _ref2, _custName, _sum }
                                ]
                            }
                        } else {
                            primaryDataset = [
                                ...primaryDataset,
                                {
                                    _tagId, _tagName, _sum, _count,
                                    detaild: [
                                        { _datetime, _docNum, _ref2, _custName, _sum }
                                    ]
                                }
                            ]
                        }

                        if (findBranch > -1) {
                            branchDataset[findBranch] = {
                                ...branchDataset[findBranch],
                                _sum: branchDataset[findBranch]._sum + _sum,
                                _count: branchDataset[findBranch]._count + _count,
                                detaild: [
                                    ...branchDataset[findBranch].detaild,
                                    { _datetime, _docNum, _ref2, _custName, _sum }
                                ]
                            }
                        } else {
                            branchDataset = [
                                ...branchDataset,
                                {
                                    _branchId, _branchName, _tagId, _tagName, _sum, _count,
                                    detaild: [
                                        { _datetime, _docNum, _ref2, _custName, _sum }
                                    ]
                                }
                            ]
                        }

                        if (findItem > -1) {
                            itemDataset[findItem] = {
                                ...itemDataset[findItem],
                                _sum: itemDataset[findItem]._sum + _sum,
                                _count: itemDataset[findItem]._count + _count,
                                detaild: [
                                    ...itemDataset[findItem].detaild,
                                    { _datetime, _docNum, _ref2, _custName, _sum }
                                ]
                            }
                        } else {
                            itemDataset = [
                                ...itemDataset,
                                {
                                    _tagId, _tagName, _itemId, _itemName, _sum, _count,
                                    detaild: [
                                        { _datetime, _docNum, _ref2, _custName, _sum }
                                    ]
                                }
                            ]
                        }

                        if (findBranchItem > -1) {
                            branchItemDataset[findBranchItem] = {
                                ...branchItemDataset[findBranchItem],
                                _sum: branchItemDataset[findBranchItem]._sum + _sum,
                                _count: branchItemDataset[findBranchItem]._count + _count,
                                detaild: [
                                    ...branchItemDataset[findBranchItem].detaild,
                                    { _datetime, _docNum, _ref2, _custName, _sum }
                                ]
                            }
                        } else {
                            branchItemDataset = [
                                ...branchItemDataset,
                                {
                                    _branchId, _branchName, _tagId, _tagName, _itemId, _itemName, _sum, _count,
                                    detaild: [
                                        { _datetime, _docNum, _ref2, _custName, _sum }
                                    ]
                                }
                            ]
                        }

                    })

                }

                this.setState({ modalOpen: true, loading: false }, () => {
                    this.props.dataActions.setJson(this.id, { primaryDataset, branchDataset, itemDataset, branchItemDataset, sumAll, countAll })
                })
            })
        })
    }

    sendAPI = (script, data, sCal) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType.OUTPUT_TYPE_DATA, ProcessType.PROCESS_TYPE_SYNC);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCal, (e) => { console.error(e) });
    }


    render() {
        let gt = this.getText;

        const divStyle = {
            align: "center",

            dir: "rtl", // dir: 'ltr'
            padding: "2% 2% 2% 2%",

            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            flexDirection: 'column',
        };

        const hourField = (field) => {
            return (<DateTimePicker
                format="HH:mm"
                value={this.state[field]}
                onChange={e => { this.setState({ [field]: e }) }}
            />)
        }

        const render = t => t
        const renderDate = t => moment(t).format("DD/MM/YYYY")
        const renderTime = t => moment(t).format("HH:mm")
        const renderSum = t => t.toFixed(2)
        const renderPrimary = (t, r) => r.key == "sumRow" ? <b>{t}</b> : t
        const getDetaild = d => {
            return ((<ResponsiveTable
                tableOnly
                dataSource={d}
                columns={[
                    { title: gt(21316), key: "_date", dataIndex: "_datetime", width: "15%", render: renderDate },
                    { title: gt(21317), key: "_time", dataIndex: "_datetime", width: "15%", render: renderTime },
                    { title: gt(21318), key: "_docNum", dataIndex: "_docNum", width: "15%", render },
                    { title: gt(21319), key: "_ref2", dataIndex: "_ref2", width: "15%", render },
                    { title: gt(21320), key: "_custName", dataIndex: "_custName", width: "25%", render },
                    { title: gt(21321), key: "_sum", dataIndex: "_sum", width: "15%", render: renderSum },
                ]}
                pagination={false}
            />))
        }

        let dataSource = this.state.viewPerBranch && this.state.viewPerItem ?
            this.props.data[this.id].branchItemDataset.map(x => {
                return {
                    key: `b${x._branchId}i${x._itemId}`,
                    branch: x._branchName,
                    item: x._itemName,
                    sum: renderSum(x._sum),
                    count: x._count,
                    detail: getDetaild(x.detaild.map(y => { return { ...y, key: y._docNum } }))
                }
            })
            : this.state.viewPerBranch ?
                this.props.data[this.id].branchDataset.map(x => {
                    return {
                        key: `b${x._branchId}i${x._tagId}`,
                        branch: x._branchName,
                        item: x._tagName,
                        sum: renderSum(x._sum),
                        count: x._count,
                        detail: getDetaild(x.detaild.map(y => { return { ...y, key: y._docNum } }))
                    }
                })
                : this.state.viewPerItem ?
                    this.props.data[this.id].itemDataset.map(x => {
                        return {
                            key: `bAlli${x._itemId}`,
                            branch: gt(21322),
                            item: x._itemName,
                            sum: renderSum(x._sum),
                            count: x._count,
                            detail: getDetaild(x.detaild.map(y => { return { ...y, key: y._docNum } }))
                        }
                    })
                    : this.props.data[this.id].primaryDataset.map(x => {
                        return {
                            key: `bAlli${x._tagId}`,
                            branch: gt(21322),
                            item: x._tagName,
                            sum: renderSum(x._sum),
                            count: x._count,
                            detail: getDetaild(x.detaild.map(y => { return { ...y, key: y._docNum } }))
                        }
                    })

        dataSource = [
            ...dataSource,
            {
                key: 'sumRow',
                branch: "",
                item: gt(21323),
                sum: renderSum(this.props.data[this.id].sumAll),
                count: this.props.data[this.id].countAll,
            }
        ]

        dataSource = dataSource.map(x => { return { ...x, avg: x.sum && x.count ? (x.sum / x.count).toFixed(2) : 0 } })

        let centralButton = (<Button onClick={() => { this.setState({ viewPerBranch: !this.state.viewPerBranch }) }}>{gt(this.state.viewPerBranch ? 21324 : 21325)}</Button>)
        let centralTagButton = (<Button onClick={() => { this.setState({ viewPerItem: !this.state.viewPerItem }) }}>{gt(this.state.viewPerItem ? 21333 : 21334)}</Button>)

        return (<div style={divStyle}>
            <Card title={(<PageToolbar title={gt(21315)} showsearch={false} actionButtons={[]} />)}
                bordered={true} style={{ width: window.innerWidth < 600 ? '95%' : 600 }}
                headStyle={{ paddingLeft: 8, paddingRight: 8, marginTop: 4, height: 56 }} >
                <Form.Item style={{ textAlign: 'center' }}>
                    <DashboardDateChecker
                        value={new Date(this.state._date)}
                        onChange={e => { this.setState({ _date: moment(e).format("YYYY-MM-DD") }) }}
                    />
                </Form.Item>
                <Form.Item style={{ textAlign: 'center' }}>
                    {gt(21326)}: {hourField('_fromHour')}  {gt(21327)}: {hourField('_toHour')} {gt(21328)}
                </Form.Item>
                <Form.Item label={gt(21329)} labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
                    <GenericSelectorBranches
                        {...this.props} multi
                        value={this.state._branchList ? this.state._branchList.split(",") : []}
                        onChange={e => { this.setState({ _branchList: e ? e.join(",") : "" }) }}
                    />
                </Form.Item>
                <Form.Item label={gt(21330)} labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
                    <GenericSelectorItemTags
                        {...this.props} multi
                        value={this.state._itemTagList ? this.state._itemTagList.split(",") : []}
                        onChange={e => { this.setState({ _itemTagList: e ? e.join(",") : "" }) }}
                    />
                </Form.Item>
                <Form.Item label={gt(21331)} labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
                    <GenericSelector
                        {...this.props}
                        multi
                        {...this.selectors[0]}
                        value={this.state._docTypeList ? this.state._docTypeList.split(",") : []}
                        onChange={e => { this.setState({ _docTypeList: e ? e.join(",") : "" }) }}
                        filterList={'1,2,8,9,22,110,202,208,222'.split(',')}
                    />
                </Form.Item>

                <div style={{ textAlign: 'center', marginTop: 15 }}>
                    <Button type="primary" onClick={this.apiTable} loading={this.state.loading}>{gt(21332)}</Button>
                </div>
            </Card>

            <GenericModal
                visible={this.state.modalOpen}
                onCancel={() => { this.setState({ modalOpen: false }) }}
                title={gt(21315)}
                width={800}
            >
                <ResponsiveTable
                    tableOnly
                    dataSource={dataSource}
                    columns={[
                        { title: centralButton, key: "branch", dataIndex: "branch", width: "25%", render: renderPrimary },
                        { title: centralTagButton, key: "item", dataIndex: "item", width: "25%", render: renderPrimary },
                        { title: gt(21335), key: "sum", dataIndex: "sum", width: "20%", render: renderPrimary },
                        { title: gt(21336), key: "count", dataIndex: "count", width: "15%", render: renderPrimary },
                        { title: gt(21337), key: "avg", dataIndex: "avg", width: "15%", render: renderPrimary },
                    ]}
                    pagination={{ pageSize: 10 }}
                    expandedRowRender={r => r.detail}
                />
            </GenericModal>

        </div>)
    }

}

export default DynamicSalesDisplay;